import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useIsJobCoach } from '@App/components/AuthProvider/auth-provider.context';
import { Select, Button, Icon } from '@nazka/nazka.mapframe.components';
import { setTransportMode as setTransportModeRedux } from '@App/components/Map/map.slice';
import { faRectanglePro } from '@fortawesome/pro-solid-svg-icons';

import theme from '@css/theme.style.json';
import { transportLabels } from './transport-select.constants';
import './transport-select.styl';

function Option({ id, label, pro }) {
  const isJobCoach = useIsJobCoach();

  return (
    <span className={`transport-select__option${id ? ` transport-select__option--${id}` : ''}${pro && !isJobCoach ? ' transport-select__option--sneak-peak' : ''}`}>
      <Icon icon={`/img/icons/transport_types/${id}.svg`} />
      {label}
      {pro && isJobCoach && (
        <Icon 
          className="transport-select__option__pro"
          icon={faRectanglePro}
        />
      )}
    </span>
  )
}

function DropDownOption({ highlighted, label, selected }) {
  return (
    <Button
      color={highlighted ? theme.color.common.grey.xxlight : theme.color.common.white}
      css={{ fontWeight: selected ? theme.typography.font.weight.bold : '' }}
      className="transport-select__menu-item"
    >
      {label}
    </Button>
  )
}

function TransportSelect({ searchType, transportType, setTransportType }) {
  const dispatch = useDispatch();
  const isJobCoach = useIsJobCoach();
  
  const setTransportMode = v => dispatch(setTransportModeRedux(v));

  const options = useMemo(() => {
    const baseOptions = [
      { 
        id: 'walking', 
        label: (<Option id="walking" label={transportLabels.walking} />),
      },
      { 
        id: 'bike', 
        label: (<Option id="bike" label={transportLabels.bike} />),
      },
      { 
        id: 'e-bike', 
        label: (<Option id="e-bike" label={transportLabels['e-bike']} />),
      },
      { 
        id: 'ov', 
        label: (<Option id="ov" label={transportLabels.ov} />),
      },
      { 
        id: 'bike_ov', 
        label: (<Option id="bike_ov" label={transportLabels.bike_ov} />),
      },
      // {
      //   id: 'car_ov',
      //   label: (<Option id="car_ov" label="Auto + trein/tram/bus" pro />),
      //   pro: true,
      // },
      {
        id: 'car',
        label: (<Option id="car" label="Auto" pro />),
        pro: true,
      },
    ];

    return baseOptions;
  }, []);

  return (
    <Select 
      css={{ display: searchType !== 'duration' && 'none' }}
      className="transport-select"
      options={options}
      value={transportType}
      onInputChange={(v) => {
        if (v?.pro && !isJobCoach) {
          document.querySelector('.home__content-block__wrapper__info').scrollIntoView({
            behavior: 'smooth',
          });
        } else {
          setTransportType(v.id);
          setTransportMode(v.id);
        }
      }}
      customMenuItems={DropDownOption}
    />
  )
}

export default TransportSelect;
